import { EnnismoreAPIClientConfig } from './interfaces';

export function getClientHeaders(config: EnnismoreAPIClientConfig) {
  if (config.membershipMode) {
    return {
      'x-client': 'booking-platform-web-membership-services',
      'x-application': 'ebe-ui-membership-services',
    };
  }

  return {
    'x-client': 'booking-platform-web',
    'x-application': 'ebe-ui',
  };
}
